export const godFatherReducer = (state, {type, payload}) => {
    switch (type) {
        case "initGodFatherList":
            return payload;
        case "addGodFather":
            return [
                ...state,
                payload //new Surrounding
            ];
        case "removeGodFather":
            console.log('ato')
            console.log(payload)
            return [
                ...state.filter((godFather) => godFather.email !== payload) //payload == godFatherId
            ];
        default:
            return state;
    }
}
